import { CAMPAIGNS, type Campaign } from './campaigns';

export type { CampaignPromoBackground as HolidayBannerBackground, CampaignPromoTextPart as HolidayBannerTextPart } from './campaigns';
import type { CampaignPromoTextPart, CampaignPromoBackground } from './campaigns';

export type HolidayBannerConfig = {
  startDate: string;
  endDate: string;
  textParts: CampaignPromoTextPart[];
  background: CampaignPromoBackground;
  campaignUrl?: string;
};

/**
 * Default banner configuration (purple background)
 * Shown when no scheduled banner is active
 *
 * Back to the free shipping callout (SSD-6599), which converts better than the
 * sampling message SSD-5677 briefly ran here. `{{threshold}}` is resolved per
 * currency from the shipping policy — the minimum differs by region, so it is
 * never hardcoded.
 */
export const DEFAULT_HOLIDAY_BANNER: HolidayBannerConfig = {
  startDate: '',
  endDate: '',
  textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for orders above {{threshold}}' }],
  background: 'purple',
};

/**
 * Holiday Banner rotation schedule, derived from the one campaign calendar in `campaigns.ts`.
 *
 * Every campaign that carries a `promo` becomes a rotation, in registry order — which is
 * significant, because overlapping windows resolve first-match-wins.
 *
 * Schedule a campaign in `CAMPAIGNS`, not here: that is what keeps the topbar flag and the
 * homepage flash-sale rail on the same window.
 */
export const HOLIDAY_BANNER_ROTATIONS: HolidayBannerConfig[] = CAMPAIGNS.filter(
  (campaign): campaign is Campaign & { promo: NonNullable<Campaign['promo']> } => Boolean(campaign.promo),
).map((campaign) => ({
  startDate: campaign.startDate,
  endDate: campaign.endDate,
  textParts: campaign.promo.textParts,
  background: campaign.promo.background,
  campaignUrl: campaign.campaignUrl,
}));

export const HOLIDAY_BANNER_TIMEZONE = 'Asia/Singapore';
